import { useState } from 'react';
import type { ReactNode } from 'react';

import { NgSearchInput } from '../forms/NgSearchInput';

export type DataGridProps<T> = {
  items: readonly T[];
  headerTemplate: ReactNode;
  rowTemplate: (item: T) => ReactNode;
  selectAction?: (item: T) => void | Promise<void>;
  searchAction?: (search: string) => readonly T[];
  hover?: boolean;
  height?: string;
};

export function DataGrid<T>({
  items,
  headerTemplate,
  rowTemplate,
  selectAction,
  searchAction,
  hover = false,
  height = '100%',
}: DataGridProps<T>) {
  const [searchedItems, setSearchedItems] = useState<readonly T[] | null>(null);
  const effectiveItems = searchedItems ?? items;

  const effectiveClass = hover ? 'table-hover' : '';

  const onSearchKeywordChanged = (search: string) => {
    if (searchAction == null) {
      return;
    }
    setSearchedItems(searchAction(search));
  };

  return (
    <>
      {searchAction != null && <NgSearchInput onSearchKeywordChanged={onSearchKeywordChanged} />}

      <div className="table-wrapper" style={{ height, overflowY: 'auto' }}>
        <table className={`table table-sm align-middle ${effectiveClass}`}>
          <thead className="sticky-top bg-white">
            <tr>{headerTemplate}</tr>
          </thead>
          <tbody>
            {effectiveItems.map((item, index) => (
              <tr
                key={index}
                onClick={() => void selectAction?.(item)}
                style={selectAction != null ? { cursor: 'pointer' } : undefined}
              >
                {rowTemplate(item)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
